var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unitNotYen === undefined)?_c('currency',{attrs:{"value":_vm.value,"unit":_vm.unit}}):_c('span',[_vm._v(_vm._s(_vm.value)+_vm._s(_vm.unitNotYen))])}
var staticRenderFns = []

export { render, staticRenderFns }